import { decodeActionCard } from '@littlebird/action-cards';
import { getSDK } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { LittlebirdMarkIcon } from '@/assets/icons/littlebird-mark';

import { ActionCardIcon } from './ActionCardIcon';

/** The chip shows the card's own icon, and the Littlebird mark until the card loads. */
export const ActionCardMentionIcon = observer(
  ({ cardId }: { cardId: string }) => {
    const card = getSDK().stores.actionCards.get(cardId);
    const decoded = card ? decodeActionCard(card) : null;
    if (!decoded) return <LittlebirdMarkIcon className="size-4" />;

    return (
      <ActionCardIcon
        content={decoded.content}
        provider={decoded.provider}
        className="size-4"
        showPerson={false}
      />
    );
  }
);
